import React, { useCallback, useMemo } from "react";

import { cancellationTableColumnsConfig } from "./cancellationTableColumnsConfig";
import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";


export const CancellationTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (cancellationId) => {
      navigate(`/cancellations/${cancellationId}`);
    },
    [navigate]
  );

  const columnDefs = useMemo(
    () => cancellationTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );

  return <Table data={data} columns={columnDefs} />;
};
